<template>
    <rkm-form
        v-if="loaded"
        ref="Form"
    >
        <rkm-row>
            <rkm-col cols="auto">
                <rkm-form-checkbox v-model="model.numeroSolicitacaoAutomatico">
                    Número de solicitação automático
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-form-checkbox v-model="model.solicitacaoAutomaticaAmbulatorio">
                    Solicitação automática (Ambulatório)
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col>
                <rkm-form-checkbox v-model="model.permiteAgendarForaOrdemPosicao">
                    Permite agendar fora da ordem de posição
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>

        <rkm-row class="mt-2">
            <rkm-col>
                <Supervisor :data="{ model }" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <Regulador :data="{ form: form.regulador, model }" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <Solicitante :data="{ form: form.solicitante, model }" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <PrestadorInterno :data="{ form: form.prestadorInterno, model }" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <PrestadorExterno :data="{ form: form.prestadorExterno, model }" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-select
                    :options="form.opcoesRetiradaProtocoloAgendamento"
                    label="Retirada de protocolo agendamento (Padrão)"
                    text-field="nome"
                    v-model="model.opcaoRetiradaProtocoloAgendamentoId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-textarea
                    :validations="validations.mensagemProtocoloSolicitacao"
                    label="Mensagem de protocolo de cadastro de solicitação"
                    v-model="model.mensagemProtocoloSolicitacao"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-textarea
                    :validations="validations.mensagemComprovanteAgendamento"
                    label="Mensagem de comprovante de agendamento"
                    v-model="model.mensagemComprovanteAgendamento"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Components.
import Supervisor from './components/supervisor/Index'
import Regulador from './components/regulador/Index'
import Solicitante from './components/solicitante/Index'
import PrestadorInterno from './components/prestador-interno/Index'
import PrestadorExterno from './components/prestador-externo/Index'

// Mixins.
import { repository, error, object, stringCase } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: {
        Supervisor,
        Regulador,
        Solicitante,
        PrestadorInterno,
        PrestadorExterno,
    },
    computed: {
        validations() {

            return {
                mensagemProtocoloSolicitacao: { max: 500 },
                mensagemComprovanteAgendamento: { max: 500 },
            }
        }
    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('regulacao.parametrizacao'),
        }

        this.load()
    },
    data: () => ({
        loaded: false,
        form: null,
        model: null
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.parametrizacao.create()
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model

                    this.$emit('data-load', { form: this.form, model: this.model })

                    this.loaded = true;
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.repositories.parametrizacao.store(this.prepareData())
                        .then(() => {

                            this.showSaveNotification()
                            this.$emit('save')
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            const data = this.clone(this.model)

            data.supervisores = data.supervisores.map(supervisor => ({
                id: supervisor.id,
                usuarioId: supervisor.usuario.id,
            }))

            data.reguladores = data.reguladores.map(regulador => ({
                id: regulador.id,
                ativo: regulador.ativo,
                infraestruturaId: regulador.infraestruturaId,
                tipoId: regulador.tipoId,
                solicitanteControlaProtocoloFechamento: regulador.solicitanteControlaProtocoloFechamento,
                exames: regulador.exames.map(exame => ({
                    id: exame.id,
                    ativo: exame.ativo,
                })),
                procedimentosCirurgicos: regulador.procedimentosCirurgicos.map(procedimentoCirurgico => ({
                    id: procedimentoCirurgico.id,
                    ativo: procedimentoCirurgico.ativo,
                })),
                especialidades: regulador.especialidades.map(especialidade => ({
                    id: especialidade.id,
                    ativo: especialidade.ativo,
                })),
            }))

            data.solicitantes = data.solicitantes.map(solicitante => ({
                id: solicitante.id,
                infraestruturaId: solicitante.infraestruturaId,
                isPpi: solicitante.isPpi,
                reguladores: solicitante.reguladores.map(regulador => ({
                    id: regulador.id,
                    infraestruturaId: regulador.infraestruturaId,
                    exames: regulador.exames.map(e => e.id),
                    procedimentosCirurgicos: regulador.procedimentosCirurgicos.map(pc => pc.id),
                    especialidades: regulador.especialidades.map(e => e.id),
                }))
            }))

            data.prestadoresInternos = data.prestadoresInternos.map(prestador => ({
                id: prestador.id,
                ativo: prestador.ativo,
                infraestruturaId: prestador.infraestruturaId,
                exames: prestador.exames.map(exame => ({
                    id: exame.id,
                    ativo: exame.ativo,
                    observacoes: exame.observacoes,
                })),
                procedimentosCirurgicos: prestador.procedimentosCirurgicos.map(procedimentoCirurgico => ({
                    id: procedimentoCirurgico.id,
                    ativo: procedimentoCirurgico.ativo,
                    observacoes: procedimentoCirurgico.observacoes,
                })),
                especialidades: prestador.especialidades.map(especialidade => ({
                    id: especialidade.id,
                    ativo: especialidade.ativo,
                    observacoes: especialidade.observacoes,
                })),
            }))

            data.prestadoresExternos = data.prestadoresExternos.map(prestador => ({
                id: prestador.id,
                ativo: prestador.ativo,
                destinoId: prestador.destinoId,
                exames: prestador.exames.map(exame => ({
                    id: exame.id,
                    ativo: exame.ativo,
                    observacoes: exame.observacoes,
                })),
                procedimentosCirurgicos: prestador.procedimentosCirurgicos.map(procedimentoCirurgico => ({
                    id: procedimentoCirurgico.id,
                    ativo: procedimentoCirurgico.ativo,
                    observacoes: procedimentoCirurgico.observacoes,
                })),
                especialidades: prestador.especialidades.map(especialidade => ({
                    id: especialidade.id,
                    ativo: especialidade.ativo,
                    observacoes: especialidade.observacoes,
                })),
            }))

            return this.camelObjectKeysToSnakeRecursive(data)
        },
    },
    mixins: [repository, error, object, stringCase],
}
</script>